import { useMutation } from "@tanstack/react-query";
import { sendResetPasswordEmail } from "../services/auth.service";
import { IForgotPasswordRequest } from "../types/auth.types";

export const useSendResetPasswordEmail = () => {
  return useMutation({
    mutationFn: (data: IForgotPasswordRequest) => sendResetPasswordEmail(data),
    onSuccess: () => {
      // Email sent successfully — caller handles UI transition via onEmailSent()
    },
    onError: (error) => {
      console.error("Failed to send reset password email:", error);
    },
  });
};
